import { createContext, useContext } from "react";

interface NavigationContext {
    blockNavigation: boolean;
    message?: string;
    setBlockNavigation: (state: boolean) => void;
    setMessage?: (message: string) => void;
}

export const NavigationContext = createContext<NavigationContext>({
    blockNavigation: false,
    setBlockNavigation: () => false,
    message: "",
    setMessage: () => "",
});

export const NavigationProvider = NavigationContext.Provider;
export const useNavigationContext = () => useContext(NavigationContext);
